import { TProductGallerySingleVariants } from '@features/cms/typescript';
import getInspirationImageSize from '@utils/getInspirationImageSize';
import theme from '@styles/theme';
export default {
  singleGallerySection: (bg: string, variant: TProductGallerySingleVariants) => ({
    pl: [0, 0, 0, 0, variant !== 'singleHorizontal' ? '18.28125vw' : 0],
    position: 'relative',
    zIndex: theme.zIndex.documentUp,
    bg,
    overflow: 'hidden'
  }),
  imageWrapper: (variant: TProductGallerySingleVariants) => ({
    overflowX: ['auto', 'auto', 'auto', 'auto', 'hidden'],
    width: ['100%', '100%', variant === 'singleVertical' ? '563px' : '918px', variant === 'singleVertical' ? '563px' : '918px', variant === 'singleHorizontal' ? '100%' : 'auto'],
    bg: 'transparent',
    border: 'none',
    margin: ['0 auto', '0 auto', '0 auto', '0 auto', 0],
    display: 'block'
  }),
  singleImageBox: (isRightText: boolean, variant: TProductGallerySingleVariants) => ({
    width: getInspirationImageSize(variant, isRightText).width,
    height: getInspirationImageSize(variant, isRightText).height,
    position: 'relative',
    display: 'block',
    border: 'none',
    margin: ['0 auto', '0 auto', '0 auto', '0 auto', 0]
  }),
  textBox: (isRight: boolean) => ({
    position: ['static', 'static', 'static', 'static', 'absolute'],
    top: '6.015625vw',
    left: !isRight && `calc(((100vw - 63.59375vw) / 2) - 0.3vw)`,
    right: isRight && `calc(((100vw - 71.5625vw) / 2) + 3.3vw)`,
    width: ['100%', '100%', '100%', '100%', '287px'],
    maxWidth: ['100%', '100%', '918px', '918px', '100%'],
    transform: ['none', 'none', 'none', 'none', `translateX(${isRight ? '50%' : '-50%'})`],
    margin: '0 auto',
    p: ['32px 32px 64px', '32px 32px 64px', '32px 32px 64px', '32px 32px 64px', 0],
    h4: {
      textAlign: 'left'
    }
  })
};